
/**
 * Module dependencies.
 */

import {
  authorizationHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  favoriteId: string,
  projectId: string,
  token: string
};

/**
 * Export `addProjectFavorite`.
 */

export async function addProjectFavorite({ favoriteId, projectId, token }: Query) {
  const endpoint = getApiEndpoint('getUserProjectFavorites', { id: projectId });

  try {
    const { data } = await request.post(endpoint, { favoriteId }, {
      headers: authorizationHeader(token)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
